export { CustomerService } from './customer.service';
export { PaymentService } from './payment.service';
export { PrintService } from './print.service';
export { FeatureService } from './feature.service';
export { TramsService } from './trams.service';
export { BaseAgentTypeaheadService } from './base-agent-typeahead.service';
export { AgentNameTypeaheadService } from './agent-name-typeahead.service';
export { AgentCodeTypeaheadService } from './agent-code-typeahead.service';
export { AmbassadorInformationSessionStorage } from './ambassador-session.service';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/index.ts